import { Component, Input, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { HighlightNew } from 'src/app/shared/models/node';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-sample-news',
  templateUrl: './sample-news.component.html',
  styleUrls: ['./sample-news.component.scss']
})
export class SampleNewsComponent implements OnInit {

  @Input() block: any;
  @Input() lang: string = '';
  public allNews: HighlightNew[] = [];
  public newsDataArrayAll: HighlightNew[] = [];
  public newsDataArrayBig: HighlightNew = {} as HighlightNew;
  public newsDataArraySmall: HighlightNew[] = [];
  public domainWebsite = environment.urlApi;
  public headerData = {
    titolo: '',
    labelLink: '',
    labelLinkUrl: ''
  }
  customOptionsNews: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    responsive: {
      0: {
        items: 1
      }
    },
    nav: false
  }

  constructor(
    public nodeService: NodeService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.setHeaderData();
    this.setNewsData();
  }

  private setHeaderData() {
    this.headerData = {
      titolo: this.block.titolo,
      labelLink: this.block.label_link,
      labelLinkUrl: ''
    }
    if (this.block.link) {
      this.headerData = {
        ...this.headerData,
        labelLinkUrl: this.block.link.url
      }
    }
  }

  private setNewsData() {
    this.nodeService.getRowTypeView(this.lang, this.block.oggetto_view, this.block.tipo_view, this.block.preview).subscribe(newsData => {
      this.allNews = newsData;
      // for desktop
      this.newsDataArrayBig = newsData[0];
      this.newsDataArraySmall = newsData.slice(0, 4);
      this.newsDataArraySmall.shift();
      // for mobile
      if (newsData.length > 4) {
        this.newsDataArrayAll = newsData.slice(0, 4);
      } else {
        this.newsDataArrayAll = newsData;
      }
    });
    // this.nodeService.getRowTypeView(this.lang, this.block.oggetto_view, this.block.tipo_view).subscribe(newsData => {
    //   if (this.block.bundle === 'blocco_tutte_le_news') {
    //     const dataAllNews = newsData.rows;
    //     // for desktop
    //     this.newsDataArrayBig = dataAllNews[0];
    //     this.newsDataArraySmall = dataAllNews.slice(0, 4);
    //     this.newsDataArraySmall.shift();
    //     // for mobile
    //     if (newsData.length > 4) {
    //       this.newsDataArrayAll = dataAllNews.slice(0, 4);
    //     } else {
    //       this.newsDataArrayAll = dataAllNews;
    //     }
    //   } else {
    //     // for desktop
    //     this.newsDataArrayBig = newsData[0];
    //     this.newsDataArraySmall = newsData.slice(0, 4);
    //     this.newsDataArraySmall.shift();
    //     // for mobile
    //     if (newsData.length > 4) {
    //       this.newsDataArrayAll = newsData.slice(0, 4);
    //     } else {
    //       this.newsDataArrayAll = newsData;
    //     }
    //   }
    // });
  }

}
